import { useMutation } from '@tanstack/react-query'
import { createPortfolio } from 'services/RewardsService'
import { CreatePortfolioRequest, Portfolio } from 'types/rewards'

export const useCreatePortfolioMutation = () =>
  useMutation<Portfolio, Error, CreatePortfolioRequest>({ mutationFn: createPortfolio })
